import { useMutation, useQueryClient } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { type UpdateAccountAccreditationsInput } from '@/gql/graphql';

const UPDATE_ACCOUNT_ACCREDITATIONS = graphql(`
  mutation UpdateAccountAccreditations(
    $input: UpdateAccountAccreditationsInput!
  ) {
    updateAccountAccreditations(input: $input) {
      mcsCertificationNumber
      mcsBatteryStorageCertified
    }
  }
`);

const useUpdateAccountAccreditations = () => {
  const queryClient = useQueryClient();

  return useMutation({
    meta: { skipGlobalErrorToast: true },
    mutationFn: (input: UpdateAccountAccreditationsInput) =>
      gqlClient.request(UPDATE_ACCOUNT_ACCREDITATIONS, { input }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountAccreditations(),
      });
      void queryClient.invalidateQueries({ queryKey: meKeys.restProfile() });
    },
  });
};

export default useUpdateAccountAccreditations;
